import { NodeSpec } from 'prosemirror-model';

import { BaseExtension } from '@lyearn/lygo-core';

import { tabBlockContent } from '../../consts/nodes';
import { NODE_NAME } from './consts';
import plugins from './plugins';

export default class Tab extends BaseExtension {
  get schema(): NodeSpec {
    return {
      attrs: {},
      defining: true,
      content: tabBlockContent,
      isolating: true,
      selectable: false,
      parseDOM: [],
      toDOM: () => ['div', { class: 'tab' }, 0],
    };
  }

  plugins = plugins;

  get name(): string {
    return NODE_NAME;
  }
}
